export const SESSION_STORAGE_KEYS = {
  upgradeFeatureIdentifier: 'upgradeFeatureIdentifier',
  geoIpInfo: 'RISER_GEOIP',
  usersCache: 'users'
} as const

type SessionStorageKey = (typeof SESSION_STORAGE_KEYS)[keyof typeof SESSION_STORAGE_KEYS]

export const useSessionStorageService = () => {
  const getItem = <T extends string | null = string>(key: SessionStorageKey): T | null => {
    if (import.meta.env.SSR) return null

    return sessionStorage.getItem(key) as T | null
  }

  const setItem = (key: SessionStorageKey, value: string) => {
    if (import.meta.env.SSR) return

    sessionStorage.setItem(key, value)
  }

  const removeItem = (key: SessionStorageKey) => {
    if (import.meta.env.SSR) return

    sessionStorage.removeItem(key)
  }

  return {
    getItem,
    setItem,
    removeItem
  }
}
